const ITEMS = [
    "Speech Delay",
    "Language Development",
    "Articulation & Pronunciation",
    "Stammering & Fluency",
    "Voice Therapy",
    "Autism & Communication",
    "Parent Guidance",
    "Better Communication",
    "Greater Confidence",
];

export const Marquee = () => (
    <div className="relative overflow-hidden border-y border-white/5 bg-navy py-5" aria-hidden="true">
        <div className="animate-marquee flex w-max items-center">
            {[...ITEMS, ...ITEMS].map((item, i) => (
                <span
                    key={i}
                    className="flex items-center whitespace-nowrap font-jakarta text-xs font-bold uppercase tracking-[0.3em] text-cream/70 md:text-sm"
                >
                    <span className="px-8">{item}</span>
                    <span className="h-1.5 w-1.5 rounded-full bg-peach" />
                </span>
            ))}
        </div>
    </div>
);
